import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {PriceRule} from '@app/models/price-rule';
import {midNight} from '@shared/helper/helpers';
import {groupBy, orderBy} from 'lodash-es';
import {DialogService} from 'primeng/dynamicdialog';
import {PriceRuleViewComponent} from '@app/modules/price-rule/price-rule-view/price-rule-view.component';
import {AppService} from '@shared/services/app.service';

@Component({
  selector: 'app-course-price-rules',
  templateUrl: './course-price-rules.component.html',
  styleUrls: ['./course-price-rules.component.scss'],
  providers: [DialogService]
})
export class CoursePriceRulesComponent implements OnChanges {
  @Input() items: PriceRule[];
  @Input() collapsed = true;
  @Output() dataChanged = new EventEmitter<string>();

  actives: PriceRule[] = [];

  inActives: PriceRule[] = [];

  constructor(private app: AppService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items && this.items) {
      const now = midNight();
      const groupBy1 = groupBy(this.items, (p) => p.isActive);
      this.actives = orderBy(groupBy1['true'] ?? [], 'priceType');
      this.inActives = orderBy(groupBy1['false'] ?? [], 'created');
    } else {
      this.actives = [];
      this.inActives = [];
    }
  }

  emitDataChanged(priceRuleId: string) {
    this.dataChanged.emit(priceRuleId);
  }
}
